import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {withErrorHandling} from '@cindedi/request-utilities/withErrorHandling';
import {Outlet} from '@remix-run/react';

export interface PublicMenuItem {
  id: string;
  label: string;
  href: string;
}

export interface PublicMenuGroup {
  id: string;
  title: string;
  items: PublicMenuItem[];
}

export interface RootPublicLoaderData {
  coordinator: string;
  telephone: string;
  address: string;
  menu: PublicMenuGroup[];
  seo: Record<string, {title: string; description: string}>;
}

export const meta: MetaFunction = function RootPublicMeta() {
  return [{title: 'Principal - Cindedi'}];
};

export const loader: LoaderFunction = withErrorHandling(async function RootPublicLoader({context: {use}}) {
  const Metadata = use('Metadata');
  const Menu = use('Menu');
  const Seo = use('Seo');

  const [coordinator, telephone, address, menu, seo] = await Promise.all([
    Metadata.findOrFail({where: {key: 'coordinator'}}),
    Metadata.findOrFail({where: {key: 'telephone'}}),
    Metadata.findOrFail({where: {key: 'address'}}),
    Menu.getPublicMenu(),
    Seo.all(),
  ]);

  return json({
    coordinator: coordinator.value,
    telephone: telephone.value,
    address: address.value,
    menu,
    seo,
  });
});

export default function RootPublicView() {
  return <Outlet />;
}
